var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "smartphone",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6668 21.3333H17.3335V24H14.6668V21.3333Z",
    fill: "#0083A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3335 5.33332C25.3335 3.86056 24.1396 2.66666 22.6668 2.66666H9.3335C7.86074 2.66666 6.66683 3.86056 6.66683 5.33332V26.6667C6.66683 28.1394 7.86074 29.3333 9.3335 29.3333H22.6668C24.1396 29.3333 25.3335 28.1394 25.3335 26.6667V5.33332ZM22.6668 5.33332H9.3335V26.6667H22.6668L22.6668 5.33332Z",
    fill: "#0083A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphone);
export default __webpack_public_path__ + "static/media/smartphone.b7884f89.svg";
export { ForwardRef as ReactComponent };